import { motion } from "framer-motion";
import { BookOpen, Trees, Heart } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { getLocalizedPath } from "@/lib/getLocalizedPath";
import { Link } from "react-router-dom";

export const ValueProposition = () => {
  const { language, translations } = useLanguage();
  const t = translations?.valueProposition;

  const values = [
    { 
      icon: BookOpen, 
      key: "montessori" as const,
      link: getLocalizedPath("/montessori-method", language)
    },
    { 
      icon: Trees, 
      key: "nature" as const,
      link: getLocalizedPath("/about", language)
    },
    { 
      icon: Heart, 
      key: "community" as const,
      link: getLocalizedPath("/about", language)
    },
  ];

  if (!t) return null;

  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={value.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <Link to={value.link}>
                <div className="group feature-card h-full hover:border hover:border-primary/20 transition-all duration-300">
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
                      <value.icon className="w-8 h-8 text-primary" />
                    </div>
                    <h3 className="text-xl font-medium text-foreground">
                      {t.items[value.key].title}
                    </h3>
                    <p className="text-muted-foreground">
                      {t.items[value.key].description}
                    </p>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
